// extracted by mini-css-extract-plugin
export default {"component":"styles__component--Kl37g","leafs":"styles__leafs--WQEMP"};